import 'whatwg-fetch';
import { polyfill as promisePolyfill } from 'es6-promise';

import React from 'react';
import ReactDOM from 'react-dom';

import '../scss/index.scss';

import App from './App';
import store from './store';

import { SESSIONITEMS_SET } from './actionDefinitions';

promisePolyfill();

const element = document.getElementById('content');
ReactDOM.render(<App />, element);

document.body.classList.remove('loading');

window.areScriptsLoaded = function() {
    return true;
};

window.getCurrentClient = function(desktopName, desktopVersion, desktopUserName) {
    const state = store.getState();
    if (
        (desktopName && desktopName !== state.session.desktopName) ||
        (desktopVersion && desktopVersion !== state.session.desktopVersion) ||
        (desktopUserName && desktopUserName !== state.session.desktopUserName)
    )
        store.dispatch({ type: SESSIONITEMS_SET, payload: { desktopName, desktopVersion, desktopUserName } });
    if (state.session && state.session.currentClient) return JSON.stringify(state.session.currentClient);
    else return false;
};

window.getSurveyVoidInMilliseconds = function() {
    const state = store.getState();
    if (state.agentSurvey && state.agentSurvey.surveyVoidInMilliseconds)
        return JSON.stringify(state.agentSurvey.surveyVoidInMilliseconds);
    else return false;
};
